export const educationData = [
    {
        id: 1,
        institution: 'Chandigarh University, Punjab',
        course: 'MCA (AI & ML)',
        startYear: '2024',
        endYear: '2026'
    },
    {
        id: 2,
        institution: 'Masai School, Bengaluru',
        course: 'MERN Stack Course',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 3,
        institution: 'Sir Ganesh Dutt College, Patna',
        course: 'B.Sc., Math(Hons)',
        startYear: '2018',
        endYear: '2021'
    },
]